import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as XLSX from 'xlsx';
// MUI Components
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { compliancesCrumb } from 'utils/breadcrumbInfo';
import LOOKUP from 'constants/lookup';
import { showSnackbar } from 'actions/CommonActions';
import { updateBCClosingInventory, updateClosingInventory, getClosingInventoryStatus } from 'actions/EntityActions';
import { getCsvReport } from 'actions/ReportsAction';
import { formInput } from 'actions/FormActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import ToggleInput from 'screens/components/basic/ToggleInput';
import SelectInput from 'screens/components/basic/SelectInput';
import NumberInput from 'screens/components/basic/NumberInput';
import ButtonFileUpload from 'screens/components/basic/ButtonFileUpload';
import FileInput from 'screens/components/basic/FileInput';
import 'styles/sass/gov/compliances.scss';

const componentName = "Compliances";

const loadDialogStyle = {
    maxWidth: 'none',
    minWidth: 'none',
    zIndex: '999999999'
};

const loadDialogcustomContentStyle = {
    width: '180px',
    maxWidth: 'none'
};

let openedWindow = null;

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

class Compliances extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            processingIconLoading: false,
            closingInventorySuccess: false
        }

        this.getFederalReport = this.getFederalReport.bind(this);
    }

    componentDidMount() {
        this.props.formInput(false, 'CompliancesInventoryAdjustDateType');
    }

    componentWillReceiveProps(newProps) {
        if (newProps.year > 0 && newProps.month > 0 && newProps.branchId > 0 && (newProps.year !== this.props.year || newProps.month !== this.props.month || newProps.branchId !== this.props.branchId)) {
            let model = {
                branchId: newProps.branchId,
                year: newProps.year,
                month: newProps.month
            }
            this.props.getClosingInventoryStatus(model);
        }

        if (newProps.closingInventoryTimeShot !== null && newProps.closingInventoryTimeShot !== undefined && this.props.closingInventoryTimeShot !== newProps.closingInventoryTimeShot) {
            this.setState({
                closingInventorySuccess: newProps.closingInventoryStatus
            })
        }
    }

    getFederalReport = () => {
        let that = this;
        this.setState({
            loading: true
        });
        let year = this.props.year;
        let month = this.props.month;
        let branch = this.props.branchId;
        openedWindow = window.open(this.props.apiURL + `unauthorized/monthlyfederalreport?year=${year}&month=${month}&branch=${branch}`);

        var pollTimer = window.setInterval(function () {
            if (openedWindow.closed !== false) {
                window.clearInterval(pollTimer);
                that.setState({
                    loading: false
                });
                that.props.showSnackbar("Downloading End");
            }
        }, 200);
    }

    getInventoryAdjustReport = () => {
        let year = this.props.inventoryAdjustYear;
        let month = this.props.inventoryAdjustMonthly;
        if (this.props.inventoryAdjustDateType) {
            month = this.props.inventoryAdjustMonth;
        }
        let branchId = this.props.inventoryAdjustBranch;
        let is_quarterly = this.props.inventoryAdjustDateType;
        let reportName = `InventoryAdjustReport_${branchId}`;
        this.props.getCsvReport(`reports/excel/getMonthlyInventoryAdjustReportMB?year=${year}&month=${month}&branchId=${branchId}&is_quarterly=${is_quarterly}`, reportName);
    }

    uploadPreviousMonthReport = (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let that = this;
        const province = this.getProvinceFromBranch(this.props.branchId);

        that.setState({
            processingIconLoading: true
        });

        reader.readAsArrayBuffer(e.target.files[0]);

        let functionToCall = null;
        if (province.toLowerCase() == "bc" || province.toLowerCase() == "british columbia") {
            functionToCall = this.processFileFromBC;
        } else if (province.toLowerCase() == "ab" || province.toLowerCase() == "alberta") {
            functionToCall = this.processFileFromAB;
        } else if (province.toLowerCase() == "on" || province.toLowerCase() == "ontario") {
            functionToCall = this.processFileFromON;
        } else if (province.toLowerCase() == "sk" || province.toLowerCase() == "saskatchewan") {
            functionToCall = this.processFileFromSK;
        } else {
            alert('province not supported!');
        }

        reader.onload = (args) => {
            try {
                functionToCall(that, args);
            } finally {
                that.setState({
                    processingIconLoading: false
                });
            }
        }

        return;
    }

    processFileFromBC = (that, args) => {
        let data = new Uint8Array(args.target.result);
        let wb = XLSX.read(data, { type: 'array' });
        let htmlstr;
        let splitedCSV;

        htmlstr = XLSX.write(wb, { sheet: wb.SheetNames[0], type: 'binary', bookType: 'csv' });
        splitedCSV = htmlstr.split('\n');

        let openInventory = splitedCSV[13].split(',');
        let receivedDomestic = splitedCSV[16].split(',');
        let receivedReturned = splitedCSV[17].split(',');
        let otherAdditions = splitedCSV[18].split(',');
        let shippedDdomestic = splitedCSV[22].split(',');
        let shippedReturned = splitedCSV[23].split(',');
        let destroyed = splitedCSV[24].split(',');
        let LostStolen = splitedCSV[25].split(',');
        let otherReductions = splitedCSV[26].split(',');
        let closeInventory = [];

        // for all the bc cannabis ids
        for (let i = 1; i <= 11; i++) {
            closeInventory.push({ BCClassOfCannabisId: i, ClosingInventory: parseInt(openInventory[i]) + parseInt(receivedDomestic[i]) + parseInt(receivedReturned[i]) + parseInt(otherAdditions[i]) - parseInt(shippedDdomestic[i]) - parseInt(shippedReturned[i]) - parseInt(destroyed[i]) - parseInt(LostStolen[i]) - parseInt(otherReductions[i]) });
        }
        let model = {
            BranchId: that.props.branchId,
            Year: that.props.year,
            Month: that.props.month,
            ClosingInventory: closeInventory
        }
        console.log(model);
        that.props.updateBCClosingInventory(model);
    }

    processFileFromON = (that, args) => {
        let data = new Uint8Array(args.target.result);
        let wb = XLSX.read(data, { type: 'array' });
        let htmlstr;
        let splitedCSV;
        let startIndex = 0;
        let endIndex = 0;
        let productArray = [];

        htmlstr = XLSX.write(wb, { sheet: wb.SheetNames[2], type: 'binary', bookType: 'csv' });
        splitedCSV = htmlstr.split('\n');
        for (let i = 0; i < splitedCSV.length; i++) {
            if (startIndex === 0 && splitedCSV[i].indexOf("Improper UPC Syntax") != -1) {
                startIndex = i + 1;
            }

            if (startIndex > 0 && splitedCSV[i].split(",")[0] == '' && splitedCSV[i].split(",")[1] == '' && splitedCSV[i].split(",")[2] == '') {
                endIndex = i;
                break;
            }
        }

        for (let i = startIndex; i < endIndex; i++) {
            let splitedData = splitedCSV[i].split(",");
            let upc = splitedData[0];
            let sku = splitedData[1];
            // Filter the array to keep only the numeric values and convert them to numbers
            const numericValues = splitedData.filter(item => !isNaN(item) && item.trim() !== "").map(Number);
            // Get the last numeric value
            const lastNumber = numericValues[numericValues.length - 1];
            // Get the second last numeric value
            const secondLastNumber = numericValues[numericValues.length - 2];
            let closeIventoryUnits = secondLastNumber;
            let closeInventoryValue = lastNumber;
            let model = {
                SKU: sku,
                UPC: upc,
                ClosingInventoryUnits: closeIventoryUnits,
                ClosingInventoryValue: closeInventoryValue
            };
            productArray.push(model);
        }
        let model = {
            BranchId: that.props.branchId,
            Year: that.props.year,
            Month: that.props.month,
            ClosingInventory: productArray
        }
        that.props.updateClosingInventory(model);
    }

    processFileFromAB = (that, args) => {
        let data = new Uint8Array(args.target.result);
        let wb = XLSX.read(data, { type: 'array' });
        let htmlstr;
        let splitedCSV;
        let startIndex = 0;
        let endIndex = 0;
        let productArray = [];

        htmlstr = XLSX.write(wb, { sheet: wb.SheetNames[0], type: 'binary', bookType: 'csv' });
        splitedCSV = htmlstr.split('\n');
        for (let i = 0; i < splitedCSV.length; i++) {
            if (startIndex === 0 && splitedCSV[i].indexOf("Product SKU") != -1) {
                startIndex = i + 1;
            }

            if (startIndex > 0 && splitedCSV[i].split(",")[0] == '') {
                endIndex = i;
                break;
            }
        }
        for (let i = startIndex; i < endIndex; i++) {
            let splitedData = splitedCSV[i].split(",");
            let SKU = splitedData[0];
            let splitDateByDollor = splitedCSV[i].split('$');
            let closeInventoryValue = splitDateByDollor[splitDateByDollor.length - 1].replace(/\D/g, '') / 100;
            let splitByDollarThenByComma = splitDateByDollor[splitDateByDollor.length - 2].split(',');
            let closeIventoryUnits = splitByDollarThenByComma[splitByDollarThenByComma.length - 2].replace(/\D/g, '');
            let model = {
                SKU: SKU,
                UPC: "",
                ClosingInventoryUnits: closeIventoryUnits,
                ClosingInventoryValue: closeInventoryValue
            };
            productArray.push(model);
        }
        let model = {
            BranchId: that.props.branchId,
            Year: that.props.year,
            Month: that.props.month,
            ClosingInventory: productArray
        }
        that.props.updateClosingInventory(model);
    }

    processFileFromSK = (that, args) => {
        let data = new Uint8Array(args.target.result);
        let decoder = new TextDecoder("utf-8");
        let text = decoder.decode(data);
        let splitedCSV = text.split('\n');
        let productArray = [];

        // COLUMNS
        // SITE ID, TIMESTAMP, TRANSACTION ID, GTIN, PRODUCT DISPLAY NAME,
        // TRANSACTION CODE, TRANSACTION TYPE, QTY, UNIT COST, UNIT PRICE, SYSTEM, NOTE

        for (let i = 1; i < splitedCSV.length; i++) {
            let splitedData = splitedCSV[i].split(",");
            if (splitedData.length != 12) continue; // skip invalid rows
            let type = splitedData[6];

            if (type.toLowerCase().indexOf("closing") != -1) {
                let gtin = splitedData[3];
                let productDisplayName = splitedData[4];
                let qty = splitedData[7];
                let unitCost = splitedData[8];
                let unitPrice = splitedData[9];

                let model = {
                    SKU: "",
                    UPC: gtin,
                    ProductDisplayName: productDisplayName,
                    ClosingInventoryUnits: qty,
                    UnitCost: unitCost,
                    UnitPrice: unitPrice
                };
                productArray.push(model);
            }
        }

        let model = {
            BranchId: that.props.branchId,
            Year: that.props.year,
            Month: that.props.month,
            ClosingInventory: productArray
        }

        that.props.updateClosingInventory(model);
    }

    getProvinceFromBranch = (branchId) => {
        const branch = this.props.brachOptions.find(item => item.value === branchId);
        if (branch){
            return branch.province;
        }
    }

    stopDownloading = () => {
        this.setState({
            loading: false
        });
        openedWindow.close();
    }

    render() {
        const styles = {
            uploadButton: {
                //marginRight
            },
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                width: '50%',
                opacity: 0
            }
        };

        let previousMonthReportText = "Upload Previous Month's Federal Report";
        let currentMonthReportText = "Download Monthly Federal Report";
        let currentMonthText = "current month";
        let previousMonthText = "previous month";
        if (this.props.year > 0 && this.props.month > 0) {
            let currentMonth = moment(`${this.props.year}-${this.props.month}-01`);
            let currentMonthFormatted = currentMonth.format('YYYY MMM');
            let previousMonth = currentMonth.subtract(1, 'months').format('YYYY MMM');
            previousMonthReportText = `Upload ${previousMonth} Federal Report`;
            currentMonthReportText = `Download ${currentMonthFormatted} Federal Report`;
            previousMonthText = previousMonth;
            currentMonthText = currentMonthFormatted;
        }
        let disableDownloadButton = true;
        let disableInventoryDownloadButton = true;
        if (this.props.year > 0 && this.props.month > 0 && this.props.branchId > 0) {
            disableDownloadButton = false;
        }

        if (this.props.inventoryAdjustYear > 0 && ((this.props.inventoryAdjustMonth > 0 && this.props.inventoryAdjustDateType) || (this.props.inventoryAdjustMonthly > 0 && !this.props.inventoryAdjustDateType)) && this.props.inventoryAdjustBranch > 0) {
            disableInventoryDownloadButton = false;
        }

        return (
            <section className="CompliancesSection">
                <Grid headerContent={compliancesCrumb}>
                    {/* <Dialog
                        modal={true}
                        open={this.state.loading}
                        contentStyle={loadDialogcustomContentStyle}
                        style={loadDialogStyle}>
                        <div className="loading">
                            <CircularProgress size={50} thickness={5} />
                            <br />
                            <h4 className="text-center">Downloading Report</h4>
                            <div className="pospaymentLoadingProblemBtn"
                                onClick={() => this.stopDownloading()}
                            >
                                Cancel
                            </div>
                        </div>
                    </Dialog> */}
                    <Dialog
                        open={this.state.loading}
                        PaperProps={{
                            sx: { ...loadDialogcustomContentStyle },
                        }}
                        sx={loadDialogStyle}
                    >
                        <div className="loading" style={{ textAlign: "center", padding: "20px" }}>
                            <CircularProgress size={50} thickness={5} />
                            <br />
                            <Typography variant="h6" component="h4" sx={{ marginTop: 2 }}>
                                Downloading Report
                            </Typography>
                            <Button
                                onTouchTap={() => this.stopDownloading()}
                                variant="outlined"
                                color="error"
                                sx={{ marginTop: 2 }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Dialog>
                    {/* <Dialog
                        modal={true}
                        open={this.state.processingIconLoading}
                        contentStyle={loadDialogcustomContentStyle}
                        style={loadDialogStyle}>
                        <div>
                            <h4 className="text-center purpleText">Processing File...</h4>
                        </div>
                    </Dialog> */}
                    <Dialog
                        open={this.state.processingIconLoading}
                        PaperProps={{
                            sx: { ...loadDialogcustomContentStyle },
                        }}
                        sx={loadDialogStyle}
                    >
                        <div style={{ textAlign: "center", padding: "20px" }}>
                            <Typography variant="h6" component="h4" className="purpleText">
                                Processing File...
                            </Typography>
                        </div>
                    </Dialog>
                    <CardSimple className="mt-2 bg-white">
                        <div className="corner-ribbon-container"><div className="corner-ribbon"><span className="whiteFontColor">GOLD VERSION</span></div></div>
                        <h4 className="text-center purpleText">Cannabis Retailer Monthly Federal Compliance Report (CRMFCR)</h4>
                        <div className="row m-0 p-5 ">
                            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                <NumberInput
                                    name={componentName + LOOKUP.report.federalReport.year.name}
                                    fullWidth={true}
                                    hintText={LOOKUP.report.federalReport.year.name}
                                    label={LOOKUP.report.federalReport.year.label}
                                    floatingLabelText={LOOKUP.report.federalReport.year.name}
                                    maxLength={4}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                <SelectInput
                                    name={componentName + LOOKUP.report.common.monthName}
                                    fullWidth={true}
                                    label={LOOKUP.report.common.month}
                                    floatingLabelText={LOOKUP.report.common.month}
                                    hintText={LOOKUP.report.common.month}
                                    options={LOOKUP.report.common.monthOption}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                <SelectInput
                                    name={componentName + LOOKUP.report.common.branchName}
                                    fullWidth={true}
                                    label={LOOKUP.report.common.branch}
                                    floatingLabelText={LOOKUP.report.common.branch}
                                    hintText={LOOKUP.report.common.branch}
                                    options={this.props.brachOptions && this.props.brachOptions.length > 0 ? this.props.brachOptions : []}
                                />
                            </div>
                        </div>
                            <div className="row m-0 pl-5">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2">
                                    <Button
                                        variant='contained'
                                        className="btnNewBrandPOS"
                                        sx={{ ...styles.uploadButton }}
                                        disabled={disableDownloadButton}
                                        onTouchTap={() => this.getFederalReport()} >
                                        {currentMonthReportText}
                                    </Button>
                                </div>
                                {disableDownloadButton && <p>* Select date and branch to activate the download button</p>}
                            </div>
                            {!this.state.closingInventorySuccess ?
                                    (
                                        <React.Fragment>
                                            <div className="row m-0 pl-5">
                                                {
                                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2">
                                                        <ButtonFileUpload
                                                            label={previousMonthReportText}
                                                            onChange={(e) => this.uploadPreviousMonthReport(e)}
                                                            className="btnNewBrandPOS"
                                                            disabled={disableDownloadButton}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            <div className="row m-0 pl-5">
                                                <p>{`* You can upload the final version of ${previousMonthText} report that you submit to government, we will keep a copy of it to avoid any validation issue in ${currentMonthText}`}</p>
                                                <p>* Before upload, please make sure the values are zero in any empty column for each product in the report.</p>
                                            </div>
                                        </React.Fragment>
                                    )
                                    :
                                    (
                                        <div className="row m-0 pl-5">
                                            <br />
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                                <span style={{ color: "#39B54A" }}>
                                                    {previousMonthText} report uploaded!&nbsp;<i className="fa fa-check-circle-o" />
                                                </span>
                                                &nbsp;
                                                &nbsp;
                                                <FileInput 
                                                    label="Re-Upload"
                                                    onChange={(e) => this.uploadPreviousMonthReport(e)} 
                                                />
                                            </div>
                                        </div>
                                    )
                            }
                            {(this.props.province == "MB" || this.props.province == "Manitoba") && (
                                    <div className="row m-0 pl-5">
                                        <div className="col-xs-10 col-sm-5 col-md-3 col-lg-3 col-xl-2">
                                            <NumberInput
                                                name={componentName + "InventoryAdjustYear"}
                                                fullWidth={true}
                                                hintText={"Inventory Adjust Year"}
                                                label={"Inventory Adjust Year"}
                                                floatingLabelText={"Inventory Adjust Year"}
                                                maxLength={4}
                                            />
                                        </div>
                                        {!this.props.inventoryAdjustDateType &&
                                            <div className="col-xs-10 col-sm-5 col-md-3 col-lg-3 col-xl-2">
                                                <SelectInput
                                                    name={componentName + "InventoryAdjustMonthly"}
                                                    fullWidth={true}
                                                    label={"Monthly"}
                                                    floatingLabelText={"Inventory Adjust Monthly"}
                                                    hintText={"Inventory Adjust Monthly"}
                                                    options={LOOKUP.report.common.monthOption}

                                                />
                                            </div>
                                        }
                                        {this.props.inventoryAdjustDateType &&
                                            <div className="col-xs-10 col-sm-5 col-md-3 col-lg-3 col-xl-2">
                                                <SelectInput
                                                    name={componentName + "InventoryAdjustMonth"}
                                                    fullWidth={true}
                                                    label={"Quarterly"}
                                                    floatingLabelText={"Inventory Adjust Quarterly"}
                                                    hintText={"Inventory Adjust Month"}
                                                    options={LOOKUP.report.common.MBInventoryAdjustMonth}
                                                />
                                            </div>
                                        }
                                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                            <SelectInput
                                                name={componentName + "InventoryAdjustBranch"}
                                                fullWidth={true}
                                                label={"Inventory Adjust Branch"}
                                                floatingLabelText={"Inventory Adjust Branch"}
                                                hintText={"Inventory Adjust Branch"}
                                                options={this.props.brachOptions && this.props.brachOptions.length > 0 ? this.props.brachOptions : []}
                                            />
                                        </div>
                                        <br />
                                        <div className="col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-4">
                                            <Button
                                                variant='contained'
                                                className="btnNewBrandPOS"
                                                sx={{ ...styles.uploadButton }}
                                                disabled={disableInventoryDownloadButton}
                                                onTouchTap={() => this.getInventoryAdjustReport()}>
                                                Download LGCA Inventory Report
                                            </Button>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                            <ToggleInput
                                                name={`${componentName}InventoryAdjustDateType`}
                                                label={"Report Type"}
                                                className="btnToggleLabel"
                                                option1="Monthly" option2 ="Quarterly"
                                            />
                                        </div>
                                    </div>
                            )}
                    </CardSimple>
                </Grid>
            </section>
        );
    }
}

function mapStatetoProps(state) {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name,
            value: item.id.toString(),
            province: item.provinceState.toLowerCase()
        });
    })
    return {
        brachOptions: brachOptions,
        branchId: state.form.CompliancesBranchOption,
        year: state.form.CompliancesYear,
        month: state.form.CompliancesMonthOption,
        province: state.common.applicationSettings.storeProvinceState,
        apiURL: state.common.store.apiUrl,
        closingInventoryStatus: state.entity.closingInventoryStatus,
        closingInventoryTimeShot: state.entity.closingInventoryTimeShot,
        inventoryAdjustYear: state.form.CompliancesInventoryAdjustYear,
        inventoryAdjustMonth: state.form.CompliancesInventoryAdjustMonth,
        inventoryAdjustMonthly: state.form.CompliancesInventoryAdjustMonthly,
        inventoryAdjustBranch: state.form.CompliancesInventoryAdjustBranch,
        inventoryAdjustDateType: state.form.CompliancesInventoryAdjustDateType
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        updateBCClosingInventory: (model) => dispatch(updateBCClosingInventory(model)),
        updateClosingInventory: (model) => dispatch(updateClosingInventory(model)),
        getClosingInventoryStatus: (model) => dispatch(getClosingInventoryStatus(model)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(Compliances);
